<template>
    <!-- wrap -->
    <div id="wrap" class="has-search">
        <!-- header -->
        <div id="header">
            <div class="container">
                <div class="header-top">
                    <div class="back">
                        <a @click="backbtn"><i /><span class="blind">뒤로가기</span></a>
                        <span>페이스매핑</span>
                    </div>

                    <div class="header-nav">
                        <a class="btn btn-reg" @click="write"><i /><span>신규 등록</span></a>
                    </div>
                </div>

                <div class="search-box">
                    <div class="form-box">
                        <div class="field-box">
                            <input v-model="param.geologist" type="text" class="txt" placeholder="관찰자명" />
                        </div>
                        <div class="field-box">
                            <div class="field flex">
                                <select v-model="param.tunnelConstructionMethod" class="search_selectbox">
                                    <option value="">
                                        터널공법
                                    </option>
                                    <option
                                        v-for="(item, index) in tunnelConstructionMethodList"
                                        :key="index"
                                        :value="item.code"
                                    >
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="field-box date">
                            <!-- <input type="date" class="txt" placeholder="YYYY.MM.DD" require> -->
                            <input
                                v-model="param.investigationDay"
                                type="date"
                                class="txt"
                                placeholder="YYYY.MM.DD"
                                require
                            />
                        </div>
                        <div class="btn-box">
                            <button type="button" class="btn btn-search" @click="search">
                                <span>검색</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- // header -->

        <!-- content-wrap -->
        <main id="content-wrap">
            <div id="contents">
                <div class="fms-work-list">
                    <div class="container">
                        <ul>
                            <li v-for="(data, index) in datas.content" :key="index">
                                <div class="work-list-box">
                                    <div
                                        class="work-summary"
                                        @click="detail(data.tunnelConstructionMethod, data.constructionCode, data.id)"
                                    >
                                        <div class="work-inbox">
                                            <div class="tit">
                                                터널방향
                                            </div>
                                            <div class="val">
                                                {{ data.constructionName }}
                                            </div>
                                        </div>

                                        <div class="work-inbox">
                                            <div class="tit">
                                                진행방향
                                            </div>
                                            <div class="val">
                                                {{ data.station }}
                                            </div>
                                        </div>

                                        <div class="work-inbox">
                                            <div class="tit">
                                                조사일
                                            </div>
                                            <div class="val">
                                                {{ data.investigationDay }} : {{ data.investigationTime }}
                                            </div>
                                        </div>
                                        <div class="work-inbox">
                                            <div class="tit">
                                                터널공법
                                            </div>
                                            <div class="val">
                                                {{ data.tunnelConstructionMethodName }}
                                            </div>
                                        </div>

                                        <div class="work-inbox">
                                            <div class="tit">
                                                관찰자
                                            </div>
                                            <div class="val">
                                                {{ data.geologist }}<span class="gap">/</span>
                                                <span
                                                    :class="approveState(data.approveState)"
                                                    v-html="approveStateText(data.approveState)"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="work-util">
                                        <a class="btn btn-modify" @click="modify(data.id)"><span>수정</span></a>
                                        <a class="btn btn-copy" @click="copy(data.id)"><span>복사</span></a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="btn-wrapper">
                            <a v-show="isAddBtn" class="btn btn-view-more" @click="more"><span>더보기</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <!-- // content-wrap -->
    </div>
    <!-- // wrap -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CodeApi from '../api/CodeApi';
import FacemappingApi from '../api/FacemappingApi';
import PageModel from '../model/PageModel';

export default {
    name: 'List',
    components: {},
    data: () => {
        return {
            datas: new PageModel(),
            param: {
                page: 1,
                rows: 5,
                sort: 'investigationDay desc,reg_dt',
                direction: 'desc',
                geologist: '',
                investigationDay: '',
                tunnelConstructionMethod: ''
            },
            tunnelConstructionMethodList: [],
            type: [],
            isAdd: false,
            isAddBtn: true
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {},
    created() {},
    mounted() {
        this.codeSettign('017');
        this.list();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        backbtn() {
            this.$router.push({
                name: 'Main'
            });
        },
        write() {
            this.$router.push({
                name: 'Step1'
            });
        },
        search() {
            this.param.page = 1;
            this.isAdd = false;
            this.list();
        },
        more() {
            this.param.page = this.param.page + 1;
            this.isAdd = true;
            this.list();
        },
        list() {
            this.showLoading();
            FacemappingApi.list(this.param).then(res => {
                this.datas.bind(res, this.isAdd);
                this.isAddBtn = (res.pageable.page + 1) * res.pageable.rows <= res.pageable.total ? true : false;
                this.hideLoading();
            });
        },
        modify(id) {
            this.$router.push({ path: `/step1/${id}` });
        },
        detail(tunnelConstructionMethod, constructionCode, id) {
            if (tunnelConstructionMethod === '017001') this.$router.push({ path: `/detail/${constructionCode}/${id}` });
            else this.$router.push({ path: `/detailTBM/${constructionCode}/${id}` });
        },
        copy(id) {
            this.param.page = 1;
            this.isAdd = false;
            FacemappingApi.copy(id).then(() => {
                this.search();
            });
        },
        approveState(approveState) {
            return approveState === 'request' ? 'type-1' : approveState === 'waiting' ? 'type-2' : 'type-3';
        },
        approveStateText(approveState) {
            return approveState === 'request'
                ? '작성중'
                : approveState === 'waiting'
                ? '결재요청'
                : approveState === 'reject'
                ? '반려'
                : '결재완료';
        },
        codeSettign(code) {
            CodeApi.subCodeList(code, 2).then(res => {
                this.tunnelConstructionMethodList = res.content;
            });
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
